import type { PostFields } from '@tribeplatform/gql-client/graphql'
import type { ClientError } from '@tribeplatform/gql-client/lib'
import {
  type Post,
  type MutationPublishPostArgs,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import {
  getDraftPostsCountKey,
  getDraftPostsKey,
} from '../../utils/keys/post.key.js'

export const usePublishPost = (options?: {
  fields?: PostFields
  useMutationOptions?: UseMutationOptions<
    Post,
    ClientError,
    MutationPublishPostArgs
  >
}) => {
  const { useMutationOptions, fields } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<Post, ClientError, MutationPublishPostArgs>(
    variables => client.posts.publishPost(variables, fields),
    {
      ...useMutationOptions,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(getDraftPostsKey())
        queryClient.invalidateQueries(getDraftPostsCountKey())

        useMutationOptions?.onSuccess?.(data, variables, context)
      },
    },
  )
}
